import { styled } from '@mui/material/styles';

export const Body = styled('div')({
    display: 'grid',
    gridGap: 16,
    padding: 16,
    width: 730,
    maxWidth: '100%',
    '@media (max-width: 1024px)': {
        padding: 12,
        width: '100%',
    },
});
